module.exports = __webpack_public_path__ + "img/timer.03ee12bf.svg";